const prefix = 'qualifications'

export enum QualificationsQueryKeys {
  QualificationsSearch = `${prefix}/QualificationsSearch`,
  QualificationsByIds = `${prefix}/QualificationsByIds`,
}
